<template>
    <div class="container">
        <div class="title-container">
            <div @click="primary_toggle=true">
                <Title :text="'Pazienti'" :selected="primary_toggle" class="title" />
            </div>
            <div @click="primary_toggle=false">
                <Title v-if="usertype.includes('gestori')" :text="'Dottori'" :selected="!primary_toggle" class="title" />
                <Title v-if="usertype.includes('dottori') && !usertype.includes('gestori')" :text="'Bolle'" :selected="!primary_toggle" class="title" />
            </div>
        </div>
        <div class="searchbar-container">
            <!-- v-if="!(usertype.includes('dottori') && !usertype.includes('gestori') && !primary_toggle)" -->
            <SearchBar 
                @pazienti="pazienti" 
                @refreshPazienti="refreshPazienti" 
                @praticheByDottore="praticheByDottore" 
                @dottori="dottori" 
                @pazientiFiltrati="pazienti" 
                @filterDatePraticheDottore="praticheByDottore"
                :case="getCase()" 
                :dottore="dottore"
            />
        </div>
        <div class="body">
            <ListaPazienti ref="listaPazienti" :key="refreshPazientiKey" v-if="primary_toggle && loaded_dottore" :dottore="getDottore()" />
            <ListaDottori ref="listaDottori" v-if="usertype.includes('gestori') && !primary_toggle" />
            <ListaPraticheDottore ref="listaPraticheDoc" v-if="usertype.includes('dottori') && !usertype.includes('gestori') && !primary_toggle && loaded_dottore" :id_dottore="dottore" />
        </div>
    </div>
</template>

<script>
import Title from '@/components/Title.vue';
import ListaPazienti from '@/components/Lista-Pazienti.vue';
import ListaDottori from '@/components/Lista-Dottori.vue';
import SearchBar from '@/components/Search-Bar.vue';
import ListaPraticheDottore from '@/components/Lista-Pratiche-Dottore.vue';
import { mixins } from "@/mixins";
export default {
    name: 'DashboardStudio',
    components: {
        Title,
        ListaPazienti,
        ListaDottori,
        ListaPraticheDottore,
        SearchBar
    },
    mixins: [mixins],
    data() {
        return {
            usertype: this.$store.getters['getUser'].user_type,
            primary_toggle: Boolean,
            dottore: "",
            loaded_dottore: false,
            refreshPazientiKey: 0,
        }
    },
    mounted(){
        // console.log(this.usertype)
    },
    beforeMount(){
        if(this.usertype.includes('dottori')){
            this.$axios
            .get(this.$apibase + '/api/users/get_username/', {
                headers: {
                    Authorization:"JWT " + localStorage.getItem('access_token')
                }
            })
            .then(response => {
                    this.dottore = response.data;
                    this.loaded_dottore = true;
                })
            .catch((e)=>{
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e.response);
            })
        }
        else {
            this.loaded_dottore = true;
        }
        this.primary_toggle = this.$store.getters['getDashboardToggle'];
    },
    beforeDestroy(){
        this.$store.dispatch('toggleDashboard', true);
    },
    methods: {
        getCase: function(){
            if(this.primary_toggle){
                if (this.usertype.includes('gestori')){
                    return 'pazienti';
                }
                if (this.usertype.includes('dottori') && !this.usertype.includes('gestori')){
                    return 'pazientiConDottore';
                }
            }
            if(!this.primary_toggle){
                if (this.usertype.includes('gestori')){
                    return 'dottori';
                }
                if(this.usertype.includes('dottori') && !(this.usertype.includes('gestori'))){
                    return "praticheDottore";
                }
            }
        },
        pazienti: function(data) {
            if (!data){
                this.$refs.listaPazienti.displaySearch = false;
                this.$refs.listaPazienti.emptySearch = true;
                this.$refs.listaPazienti.load_counter = 0;
                this.$refs.listaPazienti.getPazienti();
                return;
            }
            this.$refs.listaPazienti.pazienti = data;
            this.$refs.listaPazienti.displaySearch = true;
        },
        praticheByDottore: function(data){
            this.$refs.listaPraticheDoc.searchResults = [];
            this.$refs.listaPraticheDoc.praticheSenzaBolle = [];
            this.$refs.listaPraticheDoc.showLoadMore = false;
            
            if(!data){
                this.$refs.listaPraticheDoc.loaded = false;
                this.$refs.listaPraticheDoc.loadCounter = 0;
                this.$refs.listaPraticheDoc.showLoadMore = true;
                this.$refs.listaPraticheDoc.loadPratiche();
                return;
            }
            this.$refs.listaPraticheDoc.processResults(data);
        },
        dottori: function(data){
            this.$refs.listaDottori.lista_data = data;
        },
        getDottore: function(){
            if(this.usertype.includes('gestori'))
                return null;
            if (this.usertype.includes('dottori') && !this.usertype.includes('gestori')){
                return this.dottore;
            }
        },
        refreshPazienti: function(){
            this.refreshPazientiKey = this.refreshPazientiKey + 1;
        }
    }
}
</script>

<style scoped>
    .container{ 
        width: 70%;
        max-width: 800px;
        text-align: left;
    }
    .title-container {
        display: inline-flex;
    }
    .title {
        margin-right: 20px;
        cursor: pointer;
    }
    .body {
        padding-top: 60px;
    }
</style>